import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { validateEnv } from './config/env'
import { ConfigurationError } from './components/common/ConfigurationError'

// Validate environment configuration before rendering app
const validationResult = validateEnv();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {validationResult.success ? (
      <App />
    ) : (
      <ConfigurationError errors={validationResult.errors || ['Unknown configuration error']} />
    )}
  </React.StrictMode>,
)